import Refresh from '@crehana/compass.icons.outline/Refresh';
import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { Button } from '@crehana/compass.ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@crehana/compass.ui/v2';

import { useTranslationCreateAndEditEmailTemplates } from '@/shared/components/email-component/hooks/use-translations';

export type TReemplaceElement = {
  handleFileRemove: (e: React.MouseEvent<HTMLButtonElement>) => void; // Function to handle file removal.
  fileInputRef: React.MutableRefObject<HTMLInputElement | null>; // Reference to the file input element.
};

export const ReemplaceElement: React.FC<TReemplaceElement> = ({
  handleFileRemove, // Function passed as a prop to handle file removal.
  fileInputRef, // Reference to the file input element passed as a prop.
}) => {
  const { t } = useTranslationCreateAndEditEmailTemplates(); // Using the useTranslation hook to get the translation function.

  return (
    <section className="tw-flex tw-flex-col tw-h-full tw-justify-center tw-p-1.2 tw-w-full tw-pointer-events-auto">
      {/* Button to remove the file */}
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger
            type="button"
            className="tw-mb-auto tw-bg-neutral-light-200 tw-border tw-border-neutral-light-500 tw-border-solid tw-flex tw-items-center tw-ml-auto tw-p-0.4 tw-rounded-0.4 tw-text-neutral-light-800"
            onClick={e => {
              e.preventDefault(); // Prevents default behavior for the button click.
              handleFileRemove(e); // Calls the handleFileRemove function passed as a prop.
            }}
          >
            <Trash2 size={20} className="tw-text-current" />
          </TooltipTrigger>
          <TooltipContent align="center" side="top">
            <p>{t('DELETE_FILE')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <div className="tw-flex tw-flex-col tw-gap-1.2 tw-items-center tw-mb-auto">
        {/* Button to trigger file replacement */}
        <Button
          type="button"
          size="xs"
          variant="primary"
          className="tw-bg-primary-dark-600"
          onClick={() => fileInputRef && fileInputRef.current?.click()} // Simulates a click on the file input element when clicked
        >
          <>
            {/* Refresh icon */}
            <Refresh className="tw-fill-current" size={16} />
            {t('NOTIFICATION_REEMPLACE')} {/* Translated text for the button */}
          </>
        </Button>

        {/* Warning message */}
        <p className="tw-text-neutral-dark-300">
          {t('NOTIFICATION_IMAGE_SIZE')}
        </p>
      </div>
    </section>
  );
};
